import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const VisaIcon = (props) => {
    return (
        <Icon viewBox="0 0 41 27" cursor="pointer" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.83203 0.00012207H39.168C39.9023 0.00012207 40.5 0.605591 40.5 1.35168V25.6486C40.5 26.3947 39.9023 27.0001 39.168 27.0001H1.83203C1.09766 27.0001 0.5 26.3947 0.5 25.6486V1.35168C0.5 0.605591 1.09766 0.00012207 1.83203 0.00012207Z"
                fill="transparent"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.75 17.4923H15.4062L16.8711 8.82434H19.2148L17.75 17.4923Z"
                fill="#182E66"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.6367 8.82434L11.5039 14.7853L11.2539 13.504L10.5039 9.60559C10.5039 9.60559 10.4102 8.82434 9.44141 8.82434H5.92188L5.88281 8.97278C5.88281 8.97278 6.95703 9.19934 8.21875 9.96497L10.1563 17.4923H12.4844L16.0391 8.82434H13.6367Z"
                fill="#182E66"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.4219 14.8243L29.6406 11.4923L30.3242 14.8243H28.4219ZM33.1836 17.4923L31.4688 8.82434H29.1094C28.3164 8.82434 28.1211 9.47278 28.1211 9.47278L24.9297 17.4923H27.1602L27.6055 16.2032H30.3281L30.582 17.4923H33.1836Z"
                fill="#182E66"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.2617 10.9884L25.5625 9.19153C25.5625 9.19153 24.6289 8.82434 23.6523 8.82434C22.5977 8.82434 20.0977 9.297 20.0977 11.5978C20.0977 13.7618 23.0352 13.7853 23.0352 14.922C23.0352 16.0587 20.3984 15.8556 19.5312 15.1368L19.2148 17.0197C19.2148 17.0197 20.1641 17.4923 21.6133 17.4923C23.0625 17.4923 25.2461 16.7189 25.2461 14.6251C25.2461 12.4493 22.2852 12.2462 22.2852 11.3009C22.2852 10.3517 24.3516 10.4767 25.2617 10.9884Z"
                fill="#182E66"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9609 13.4923L10.25 9.60559C10.25 9.60559 10.1641 8.82434 9.24609 8.82434H5.91797L5.88281 8.97278C5.88281 8.97278 7.48047 9.32434 9.01563 10.6486C10.4805 11.9142 10.9609 13.4923 10.9609 13.4923Z"
                fill="#182E66"
            />
        </Icon>
    )
}

VisaIcon.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.string,
}

export default VisaIcon
